<template>
  <div class="plus-container">
    <ul>
      <li class="plus-item" v-for="item in dataList" :key="item">
        <img class="plus-img" :src="item" @click="handleClick(item)" >
      </li>
      <van-overlay :show="visible" @click="visible = false">
        <div class="wrapper">
          <div class="block" ref="overlayImgRef">
            <img class="img" :src="current" />
          </div>
        </div>
      </van-overlay>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      current: '',
      dataList: [
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_00.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_01.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_02.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_03.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_04.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_05.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_06.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_07.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_08.png',
        'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/PLUS/PLUS_09.png',
      ]
    }
  },
  mounted() {
    this.ele = this.$refs.overlayImgRef
    this.ele.addEventListener('touchstart', this.touchStart)
    this.ele.addEventListener('touchmove', this.touchMove)
    this.ele.addEventListener('touchend', this.touchEnd)
  },
  methods: {
    handleClick(item) {
      this.current = item
      this.visible = true

      this.ele.style.transform = ''
    },
    touchStart(e) {
      e.preventDefault();
      this.start = [];
      this.istouch = false;
      if (e.touches.length >= 2) {
        this.istouch = true
        this.start = e.touches
      } else if (e.touches.length === 1) {
        this.touches = {}
        this.istouch = true
        this.touches.pageX = e.touches[0].pageX
        this.touches.pageY = e.touches[0].pageY
      }
    },
    touchMove(e) {
      e.preventDefault();
      if (e.touches.length >= 2 && this.istouch) {
        let now = e.touches;
        let scale = this.getDistance(now[0], now[1]) / this.getDistance(this.start[0], this.start[1])
        this.scale = scale.toFixed(2);

        this.ele.style.transform = `scale(${this.scale})`
      } else if (e.touches.length === 1 && this.istouch) {
        let deltaX = e.touches[0].pageX - this.touches.pageX
        let deltaY = e.touches[0].pageY - this.touches.pageY

        this.ele.style.transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${this.scale})`;
      }
    },
    touchEnd() {
      if (this.istouch) {
        this.istouch = false
      }
    },
    getDistance(p1, p2) {
      let x = p2.pageX - p1.pageX;
      let y = p2.pageY - p1.pageY;
      return Math.sqrt((x * x) + (y * y));
    },
    gesturemove() {
      this.ele.style.transform = `scale(${this.scale})`
    }
  },
  unmounted() {
    this.ele.removeEventListener('touchstart', this.touchStart)
    this.ele.removeEventListener('touchmove', this.touchMove)
    this.ele.removeEventListener('touchend', this.touchEnd)
  }
}
</script>

<style lang="scss" scoped>
.plus-container {
  max-width: 500px;
  margin: 0 auto;
  ul {
    width: 100%;
  }
  .plus-item {
    width: 100%;
    font-size: 0;
    display: block;
    img {
      width: 100%;
      display: inline-block;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      width: 80%;
      background-color: #fff;
      transform-origin: center center;
      transition: all .1s;
      .img {
        width: 100%;
      }
    }
  }
}
</style>